export enum TIMELINE_DISPLAY_TYPE {
  PROGRESS_BAR = 'PROGRESS_BAR',
  FILMSTRIP = 'FILMSTRIP',
  NONE = 'NONE'
}
